import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { API, CustomAxiosError } from "../../../../../logics/api-config";

export interface UpdateBookingStatusPayload {
    ris_id: number;
    booking_id: number;
    status: 9 | 17;
}

const useApiUpdateBookingStatus = (
    invalidateKeys?: (string | number)[]
): UseMutationResult<void, CustomAxiosError, UpdateBookingStatusPayload, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<void, CustomAxiosError, UpdateBookingStatusPayload>(
        async ({ ris_id, booking_id, status }) => {
            await API.put(`/accounting/recap/restaurant/${ris_id}/bookings/${booking_id}/change_status/${status}`);
        },
        {
            onSuccess: async () => {
                if (invalidateKeys && invalidateKeys.length > 0) {
                    await queryClient.invalidateQueries(invalidateKeys);
                } else {
                    await queryClient.invalidateQueries(["getAccountingBookingRecap"]);
                    await queryClient.invalidateQueries(["getBookingsDetail"]);
                }
            },
        }
    );
};

export default useApiUpdateBookingStatus;
